import apiClient from '../api/client';

/**
 * Uploads a profile picture using a secure backend-generated presigned URL.
 * This avoids the need for hardcoded AWS credentials in the frontend.
 * 
 * @param {File} file - The image file to upload (usually from a cropper)
 * @returns {Promise<string>} - The permanent S3 URL of the uploaded image
 */
export const uploadProfilePicture = async (file) => {
    try {
        // 1. Request a presigned URL from the backend
        // This endpoint returns { uploadUrl, finalUrl, key }
        const data = await apiClient('upload-profile-pic-url');
        
        if (!data || !data.uploadUrl) {
            throw new Error("Failed to obtain upload URL from backend");
        }

        const { uploadUrl, finalUrl } = data;

        // 2. Upload the file directly to S3 using the presigned URL
        // We use the standard fetch API for this PUT request
        const s3Response = await fetch(uploadUrl, {
            method: 'PUT',
            body: file,
            headers: {
                'Content-Type': 'image/jpeg'
            }
        });

        if (!s3Response.ok) {
            const errorText = await s3Response.text();
            console.error("S3 Upload Failed:", errorText);
            throw new Error(`S3 upload failed with status ${s3Response.status}`);
        }

        // Return the permanent URL to be stored in the user profile
        return finalUrl;

    } catch (err) {
        console.error("Profile picture upload utility failed:", err);
        throw err;
    }
};
